import React from "react";
import PropTypes from "prop-types";
import "./style.scss";
import { canUseDOM } from "../../utils/dom";

const RedirectByDevice = ({ rendering, fields }) => {
  const { android, iphone, ipad, desktop } = fields;
  const options = { android: android.value.href, iphone: iphone.value.href, ipad: ipad.value.href, desktop: desktop.value.href };

  const GetDeviceType = () => {
    for (const prop in options) {
      if (typeof navigator === "object" && navigator.userAgent.toLowerCase().indexOf(prop) > -1) return prop;
    }
    return "desktop";
  };

  const Redirect = () => {
    if (canUseDOM()) {
      const device = GetDeviceType();

      if (options[device]) {
        window.location.href = options[device];
      }
    }

    return null;
  };

  return (
    <div className="app-redirect-page" datasourceid={rendering.dataSource}>
      <Redirect />
    </div>
  );
};

RedirectByDevice.propTypes = {
  options: PropTypes.shape({
    android: PropTypes.string,
    iphone: PropTypes.string,
    ipad: PropTypes.string,
    desktop: PropTypes.string
  })
};

export default RedirectByDevice;
